<template>
    <modal
        :exibir="exibirModal"
        titulo="Convite"
        largura="500"
        @fecharModal="fecharModal"
    >
        <template v-slot:conteudo>
            <az-container v-if="exibirModal">
                <div>
                    <campo-apresentacao label-padrao="Documento" :text="documento.titulo || documento.tipo | textoSemValorSimples" :maxTruncate="50"/>
                </div>

                <v-form
                    ref="form"
                    lazy-validation
                    class="az-form-content px-0 py-0 d-flex flex-column"
                    style="height: auto !important;"
                    @submit="adicionarSignatario"
                >
                    <v-text-field
                        v-model="emailSignatario"
                        name="email"
                        placeholder="E-mail do signatário"
                        v-validate="'required|email|max:255'"
                        maxlength="255"
                        class="mt-0"
                        :error-messages="errors.collect('email')"
                    >
                        <v-btn
                            icon
                            small
                            slot="append"
                            color="primary"
                            @keyup.enter="adicionarSignatario"
                            @click="adicionarSignatario"
                        >
                            <v-icon size="18">
                                add_circle
                            </v-icon>
                        </v-btn>
                    </v-text-field>
                </v-form>

                <div class="mt-2" v-if="temSignatariosAConvidar">
                    <p class="estilo-label mb-2">
                        Signatários à convidar:
                    </p>

                    <div
                        v-for="(signatario, indexSignatario) in signatariosAConvidar"
                        :key="indexSignatario"
                        class="d-flex justify-space-between align-center"
                    >
                        <div class="texto">
                            {{ signatario }}
                        </div>

                        <v-btn icon @click="removerSignatarioAConvidar(signatario)" small>
                            <v-icon size="18">
                                remove_circle
                            </v-icon>
                        </v-btn>
                    </div>
                </div>

                <div :class="(!temSignatariosAConvidar) ? 'mt-2' : 'mt-6'" v-if="convidados && convidados.length > 0">
                    <p class="estilo-label  mb-2">
                        Signatários convidados:
                    </p>


                    <div
                        v-for="(convidado, indexConvidado) in convidados"
                        :key="indexConvidado"
                        class="d-flex justify-space-between align-center pb-2"
                    >
                        <div class="d-flex justify-start align-center">
                            <v-icon
                                size="13"
                                :color="signatarioAssinou(convidado.situacao) ? 'green' : ''"
                            >
                                {{ signatarioAssinou(convidado.situacao) ? 'fas fa-check' : 'fas fa-clock' }}
                            </v-icon>

                            <div class="texto ml-2">
                                {{ convidado.email }}
                            </div>
                        </div>

                        <v-btn
                            v-if="!signatarioAssinou(convidado.situacao)"
                            icon
                            small
                            @click="tratarRemoverConvidado(convidado)"
                        >
                            <v-icon size="13" color="red">
                                fas fa-trash
                            </v-icon>
                        </v-btn>
                    </div>
                </div>
            </az-container>
        </template>

        <template v-slot:acoes>
            <div class="az-actions-form">
                <botao
                    esconder-icone
                    texto-botao="CANCELAR"
                    @click="fecharModal"
                />

                <botao-primario
                    esconder-icone
                    texto-botao="CONVIDAR"
                    @click="convidar"
                />
            </div>
        </template>
    </modal>
</template>

<script>
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/core/constants'
    import Modal from '@/views/components/modal/Modal.vue'
    import Botao from '@/views/components/botoes/Botao.vue'
    import BotaoPrimario from '@/views/components/botoes/BotaoPrimario.vue'
    import CampoApresentacao from '@/views/components/campos/CampoApresentacao.vue'

    export default {
        name: 'ModalConvidarSignatarios',

        components: {
            CampoApresentacao,
            BotaoPrimario,
            Botao,
            Modal
        },

        data() {
            return {
                exibirModal: false,
                documento: {},
                emailSignatario: '',
                signatariosAConvidar: [],
                convidados: [],
            }
        },

        computed: {
            temSignatariosAConvidar() {
                return Boolean(this.signatariosAConvidar && this.signatariosAConvidar.length > 0)
            },
        },

        methods: {
            ...mapActions({
                buscarSignatarios: actionTypes.DOCUMENTO.BUSCAR_SIGNATARIOS,
                convidarSignatarios: actionTypes.DOCUMENTO.CONVIDAR_SIGNATARIOS,
                removerSignatario: actionTypes.DOCUMENTO.REMOVER_SIGNATARIO,
            }),
            async abrirModal(doc) {
                this.documento = {...doc}
                await this.buscarConvidados()
                this.exibirModal = true
            },
            fecharModal() {
                this.exibirModal = false
                this.resetarDados()
            },
            resetarDados() {
                this.resetarDadosConvite()
                this.documento = {}
            },
            resetarDadosConvite() {
                this.resetarEmail()
                this.signatariosAConvidar = []
                this.convidados = []
            },
            resetarEmail() {
                this.emailSignatario = ''
            },
            async atualizarConvidados() {
                await this.buscarConvidados()
                this.$emit('atualizarConvidados')
            },
            async buscarConvidados() {
                this.convidados = await this.buscarSignatarios(this.documento.idExterno) || []
            },
            signatarioAssinou(situacao) {
                return situacao === 'ASSINADO'
            },
            async validaPodeConvidar() {
                if (!await this.$validator._base.validateAll()) return false

                if (!this.emailSignatario) {
                    this.mostrarNotificacaoErro('E-mail do signatário não informado')
                    return false
                }

                if (
                    this.signatariosAConvidar.includes(this.emailSignatario)
                    ||
                    (this.convidados && this.convidados.length && this.convidados.filter(({ email }) => email === this.emailSignatario).length > 0)
                ) {
                    this.mostrarNotificacaoAviso('E-mail já incluído na listagem')
                    return false
                }

                const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                if (!regex.test(this.emailSignatario)) {
                    this.mostrarNotificacaoErro('Formato de E-mail inválido')
                    return false
                }

                return true
            },
            async adicionarSignatario(e) {
                if (e) e.preventDefault()

                if (!await this.validaPodeConvidar()) return

                this.signatariosAConvidar.push(this.emailSignatario)
                this.resetarEmail()
            },
            removerSignatarioAConvidar(emailSignarioRemover) {
                this.signatariosAConvidar.splice(this.signatariosAConvidar.indexOf(emailSignarioRemover), 1)
            },
            validaSignatariosJaConvidados() {
                let existeSignatarioJaConvidado = false

                if (this.convidados && this.convidados.length) {
                    existeSignatarioJaConvidado = this.convidados
                        .filter(({ email }) => this.signatariosAConvidar.includes(email))
                        .map(({ email }) => email)
                }

                if (existeSignatarioJaConvidado && existeSignatarioJaConvidado.length > 0) {
                    const mensagem = (existeSignatarioJaConvidado.length === 1)
                        ? `O signatário: ${existeSignatarioJaConvidado[0]} já foi convidado`
                        : `Os signatários: ${existeSignatarioJaConvidado.join(', ')} já foram convidados`

                    this.mostrarNotificacaoErro(mensagem)
                    return false
                }

                return true
            },
            validaConvite() {
                if (this.emailSignatario) {
                    this.mostrarNotificacaoAviso(`O e-mail ${this.emailSignatario} não foi adicionado a lista de signatários à convidar`)
                    return false
                }

                if (!this.temSignatariosAConvidar) {
                    this.mostrarNotificacaoErro('Nenhum signatário foi adicionado')
                    return false
                }

                if (new Set(this.signatariosAConvidar).size !== this.signatariosAConvidar.length) {
                    this.mostrarNotificacaoErro('Signatários duplicados na lista de convites. Necessário remover os duplicados.')
                    return false
                }

                return this.validaSignatariosJaConvidados()
            },
            async convidar() {
                if (!this.validaConvite()) return
                await this.convidarSignatarios({
                    idExterno: this.documento.idExterno,
                    signatarios: this.signatariosAConvidar
                })
                this.resetarEmail()
                this.signatariosAConvidar = []
                await this.atualizarConvidados()
                this.fecharModal()
                this.mostrarNotificacaoSucessoDefault()
            },
            validarRemocaoConvidado(convidado) {
                if (this.signatarioAssinou(convidado.situacao)) {
                    this.mostrarNotificacaoErro('Signatário já assinou.')
                    return false
                }

                return true
            },
            tratarRemoverConvidado(convidado) {
                if (!this.validarRemocaoConvidado(convidado)) return

                this.mostrarConfirmacao({
                    titulo: 'Atenção',
                    html: `Deseja remover o signatário <strong>${convidado.email}</strong>?`,
                    textoBotaoCancel: 'Não',
                    textoBotaoConfirm: 'Sim',
                    icon: 'warning'
                }, async (result) => {
                    if (result.isConfirmed) await this.removerConvidado(convidado)
                })
            },
            async removerConvidado({email}) {
                await this.removerSignatario({
                    idExterno: this.documento.idExterno,
                    emailSignatario: email
                })
                await this.atualizarConvidados()
            }
        }
    }
</script>

<style lang="stylus">
    .texto
        font-size 13px
        color #777 !important
</style>

